<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 5px;padding: 1px;">
                <el-table :data="applyDetailTableData" :header-cell-style="{ background: '#FFCCCC',color: '#000000' }">
                    <el-table-column label="领用物品类别" prop="itemTypeName"></el-table-column>
                    <el-table-column label="领用物品名称" prop="itemName"></el-table-column>
                    <el-table-column label="领用物品型号" prop="itemModel"></el-table-column>
                    <el-table-column label="库存数量" prop="originalQuantity"></el-table-column>
                    <el-table-column label="领用数量" prop="applyQuantity"></el-table-column>
                    <el-table-column label="单位" prop="itemUnit"></el-table-column>
                    <el-table-column label="报废原因备注" prop="remark"></el-table-column>
                </el-table>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>

            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete" :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
// Author THQ
// Date 2025-04-08 13:29:31
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import emApiMixin from "@/mixin/em/common/api";

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete.vue";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine.vue";

export default {
    name: "ppeApplyScrapWorkflowTaskView",
    mixins: [emWorkflowTaskMixin, workflowTaskMixins, emApiMixin],
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    data() {
        return {
            applyDetailTableData: []
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        config() {
            return {
                'task1': {
                    name: '发起人添加报废明细',
                    variables: [
                        {
                            label: '发起报废申请：',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '发起报废'},
                                {value: 2, text: '结束报废'}
                            ],
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    approveToNextTask: {
                        1: 'task2',
                        2: 'end_cancel'
                    },
                    changeTag: (_, approve) => {
                        return this.buildTag('needApprove', approve === 1);
                    },
                    withAttachment: true,
                    //withComment: true,
                    postByApprove: (approve) => {
                        return {
                            // 更新报废发起日期
                            url: this.$store.state.ppeApplyScrap.baseModuleUrl + `/ppeApplyScrap/updateApplyDate?flowId=${this.$_emWorkflowTaskMixin_businessKey}&approvedStatus=${approve}`,
                            data: {}
                        };
                    },
                },
                'task2': {
                    name: 'PPE主管审核报废',
                    variables: [
                        {
                            label: '报废审核结果：',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '审核通过'},
                                {value: 2, text: '审核驳回'}
                            ],
                            require: true,
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    approveToNextTask: {
                        1: 'task3',
                        2: 'task1'
                    },
                    withAttachment: true,
                    //withComment: true,
                    postByApprove: (approve) => {
                        return {
                            url: this.$store.state.ppeApplyScrap.baseModuleUrl + `/ppeApplyScrap/doAfterTaskCommit?flowId=${this.$_emWorkflowTaskMixin_businessKey}&approvedStatus=${approve}`,
                            data: {}
                        };
                    },
                },
                'task3': {
                    name: '库管员报废',
                    variables: [
                        {
                            label: '报废执行结果：',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '报废完成'},
                                {value: 2, text: '报废驳回'}
                            ],
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    approveToNextTask: {
                        1: 'end_finish',
                        2: 'task1'
                    },
                    withAttachment: true,
                    //withComment: true
                    postByApprove: (approve) => {
                        return {
                            url: this.$store.state.ppeApplyScrap.baseModuleUrl + `/ppeApplyScrap/doAfterTaskFinish?flowId=${this.$_emWorkflowTaskMixin_businessKey}&approvedStatus=${approve}`,
                            data: {}
                        };
                    },
                },
                'EndEvent': {
                    name: '结束'
                }
            }
        }
    },
    methods: {
        queryApplyDetail() {
            this.$store.dispatch("api/post", {
                url: this.$store.state.ppeApplyScrap.baseModuleUrl + '/ppeApplyScrapDetail/findByFilter',
                data: {
                    flowIdFilter: this.$_emWorkflowTaskMixin_businessKey
                }
            }).then(res => {
                this.applyDetailTableData = res.data.list
            })
        }
    },
    mounted() {
        this.queryApplyDetail();
    }
};
</script>